export default function isStorybook() {
  return typeof window !== 'undefined' && !!window?.__IS_STORYBOOK__;
}
